import React from 'react';
import { InnerIconProps } from '../PlatformIcon';

export default function ServerIcon({ color }: InnerIconProps) {
  return (
    <>
      <title>Server</title>
      <path
        d='M16 3.75H4c-.827 0-1.5.673-1.5 1.5v3c0 .827.673 1.5 1.5 1.5h12c.827 0 1.5-.673 1.5-1.5v-3c0-.827-.673-1.5-1.5-1.5ZM4 8.25v-3h12l.002 3H4Zm12 3H4c-.827 0-1.5.673-1.5 1.5v3c0 .827.673 1.5 1.5 1.5h12c.827 0 1.5-.673 1.5-1.5v-3c0-.827-.673-1.5-1.5-1.5Zm-12 4.5v-3h12l.002 3H4Z'
        fill={color}
      />
      <path
        d='M13.75 6h1.5v1.5h-1.5V6ZM11.5 6H13v1.5h-1.5V6Zm2.25 7.5h1.5V15h-1.5v-1.5Zm-2.25 0H13V15h-1.5v-1.5Z'
        fill={color}
      />
    </>
  );
}
